/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { MetricDefinitions } from "../operationsInterfaces/index.js";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers.js";
import * as Parameters from "../models/parameters.js";
import { MonitorManagementClientContext } from "../monitorManagementClientContext.js";
import {
  MetricDefinitionsListAtSubscriptionScopeOptionalParams,
  MetricDefinitionsListAtSubscriptionScopeResponse,
  MetricDefinitionsListOptionalParams,
  MetricDefinitionsListResponse
} from "../models/index.js";

/** Class containing MetricDefinitions operations. */
export class MetricDefinitionsImpl implements MetricDefinitions {
  private readonly client: MonitorManagementClientContext;

  /**
   * Initialize a new instance of the class MetricDefinitions class.
   * @param client Reference to the service client
   */
  constructor(client: MonitorManagementClientContext) {
    this.client = client;
  }

  /**
   * Lists the metric definitions for the subscription.
   * @param subscriptionId The ID of the target subscription.
   * @param region The region where the metrics you want reside.
   * @param options The options parameters.
   */
  listAtSubscriptionScope(
    subscriptionId: string,
    region: string,
    options?: MetricDefinitionsListAtSubscriptionScopeOptionalParams
  ): Promise<MetricDefinitionsListAtSubscriptionScopeResponse> {
    return this.client.sendOperationRequest(
      { subscriptionId, region, options },
      listAtSubscriptionScopeOperationSpec
    );
  }

  /**
   * Lists the metric definitions for the resource.
   * @param resourceUri The identifier of the resource.
   * @param options The options parameters.
   */
  list(
    resourceUri: string,
    options?: MetricDefinitionsListOptionalParams
  ): Promise<MetricDefinitionsListResponse> {
    return this.client.sendOperationRequest(
      { resourceUri, options },
      listOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const listAtSubscriptionScopeOperationSpec: coreClient.OperationSpec = {
  path:
    "/subscriptions/{subscriptionId}/providers/Microsoft.Insights/metricDefinitions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.SubscriptionScopeMetricDefinitionCollection
    },
    default: {
      bodyMapper: Mappers.ErrorContract
    }
  },
  queryParameters: [
    Parameters.apiVersion,
    Parameters.region,
    Parameters.metricnamespace
  ],
  urlParameters: [Parameters.$host, Parameters.subscriptionId],
  headerParameters: [Parameters.accept],
  serializer
};
const listOperationSpec: coreClient.OperationSpec = {
  path: "/{resourceUri}/providers/Microsoft.Insights/metricDefinitions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.MetricDefinitionCollection
    },
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion, Parameters.metricnamespace],
  urlParameters: [Parameters.$host, Parameters.resourceUri],
  headerParameters: [Parameters.accept],
  serializer
};
